/**
 * Status of market segment.
 * tag: 2542
 * @readonly
 * @enum {number} (int)
 */
export enum MarketSegmentStatus {
  Active = 1,
  Inactive = 2,
  Published = 3,
}
